<template>
    <layout>
        <page-search />
    </layout>
</template>

<script>
import Layout from '@/layouts/Layout.vue';
import PageSearch from '@/components/search/Claims.vue';

import Navigation from '@/models/navigation.js';

export default {
    components: {
        Layout,
        PageSearch,
    },
    mounted() {
        Navigation.setCurrentLink('claim');
    },
};
</script>
